import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["aria-label", "aria-expanded", "aria-activedescendant", "title"]
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = ["id", "aria-selected", "onPointermove", "onClick"]
const _hoisted_4 = { class: "option-label" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 0,
  viewBox: "0 0 24 24",
  fill: "none",
  "aria-hidden": "true"
}

import { computed, nextTick, onBeforeUnmount, ref, watch } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'StudioSelect',
  props: {
    modelValue: {},
    options: {},
    label: {},
    showId: { type: Boolean, default: false },
    compact: { type: Boolean, default: false },
    placeholder: { default: "未设置" }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const trigger = ref<HTMLButtonElement>();
const menu = ref<HTMLElement>();
const open = ref(false);
const active = ref(0);
const position = ref({ left: "0px", top: "0px", width: "280px", maxHeight: "320px" });
const menuId = `studio-select-${crypto.randomUUID()}`;
const choices = computed(() => props.options.some(item => item.id === props.modelValue)
  ? props.options : [{ id: props.modelValue, label: props.modelValue || props.placeholder }, ...props.options]);
const selected = computed(() => choices.value.find(item => item.id === props.modelValue)!);
const selectedLabel = computed(() => !props.showId || selected.value.label === selected.value.id ? selected.value.label : `${selected.value.label}（${selected.value.id}）`);

async function show() {
  if (open.value || !trigger.value) return;
  const rect = trigger.value.getBoundingClientRect();
  const width = Math.min(Math.max(280, rect.width), window.innerWidth - 16);
  const below = window.innerHeight - rect.bottom - 16;
  const above = rect.top - 16;
  const upward = below < 240 && above > below;
  const height = Math.min(320, Math.max(0, upward ? above : below));
  position.value = { left: `${Math.max(8, Math.min(rect.right - width, window.innerWidth - width - 8))}px`,
    top: `${upward ? Math.max(8, rect.top - height - 6) : rect.bottom + 6}px`, width: `${width}px`, maxHeight: `${height}px` };
  active.value = Math.max(0, choices.value.findIndex(item => item.id === props.modelValue));
  open.value = true;
  document.addEventListener("pointerdown", outside, true);
  document.addEventListener("scroll", onScroll, true);
  window.addEventListener("resize", close);
  await nextTick();
  if (upward && menu.value) position.value.top = `${Math.max(8, rect.top - menu.value.offsetHeight - 6)}px`;
  revealActive();
}
function close() {
  open.value = false;
  document.removeEventListener("pointerdown", outside, true);
  document.removeEventListener("scroll", onScroll, true);
  window.removeEventListener("resize", close);
}
function outside(event: PointerEvent) {
  const path = event.composedPath();
  if (!path.includes(trigger.value!) && !path.includes(menu.value!)) close();
}
function onScroll(event: Event) {
  if (!menu.value?.contains(event.target as Node)) close();
}
function revealActive() { menu.value?.querySelectorAll<HTMLElement>('[role="option"]')[active.value]?.scrollIntoView({ block: "nearest" }); }
function select(index: number) {
  const item = choices.value[index];
  if (!item) return;
  close();
  if (item.id !== props.modelValue) emit("update:modelValue", item.id);
}
function keydown(event: KeyboardEvent) {
  if (event.key === "Tab") { close(); return; }
  if (!["ArrowDown", "ArrowUp", "Home", "End", "Enter", " ", "Escape"].includes(event.key)) return;
  event.preventDefault();
  event.stopPropagation();
  if (event.key === "Escape") { close(); return; }
  if (!open.value) { void show(); return; }
  if (event.key === "Enter" || event.key === " ") { select(active.value); return; }
  if (event.key === "Home") active.value = 0;
  else if (event.key === "End") active.value = choices.value.length - 1;
  else active.value = (active.value + (event.key === "ArrowDown" ? 1 : -1) + choices.value.length) % choices.value.length;
  revealActive();
}
watch(() => props.modelValue, close);
watch(() => props.options, close);
onBeforeUnmount(close);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["studio-select", { compact: __props.compact }])
  }, [
    _createElementVNode("button", {
      ref_key: "trigger",
      ref: trigger,
      type: "button",
      class: _normalizeClass(["style-trigger", { 'is-open': open.value }]),
      role: "combobox",
      "aria-label": __props.label,
      "aria-haspopup": "listbox",
      "aria-expanded": open.value,
      "aria-controls": menuId,
      "aria-activedescendant": open.value ? `${menuId}-${active.value}` : undefined,
      title: selectedLabel.value,
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (open.value ? close() : show()), ["stop"])),
      onKeydown: keydown,
      onBlur: close
    }, [
      _createElementVNode("span", null, _toDisplayString(selectedLabel.value), 1),
      _cache[4] || (_cache[4] = _createElementVNode("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true"
      }, [
        _createElementVNode("path", { d: "m6 9 6 6 6-6" })
      ], -1))
    ], 42, _hoisted_1),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (open.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            id: menuId,
            ref_key: "menu",
            ref: menu,
            class: "style-menu dsfg-typography",
            style: _normalizeStyle(position.value),
            role: "listbox",
            "aria-label": `${__props.label}列表`,
            onPointerdown: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent","stop"])),
            onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
            onWheel: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(choices.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                id: `${menuId}-${index}`,
                key: item.id,
                class: _normalizeClass(["style-option", { 'is-selected': item.id === __props.modelValue, 'is-active': index === active.value }]),
                role: "option",
                "aria-selected": item.id === __props.modelValue,
                onPointermove: ($event: any) => (active.value = index),
                onClick: ($event: any) => (select(index))
              }, [
                _createElementVNode("span", _hoisted_4, [
                  _createElementVNode("strong", null, _toDisplayString(item.label), 1),
                  (__props.showId && item.id && item.id !== item.label)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_5, _toDisplayString(item.id), 1))
                    : _createCommentVNode("", true)
                ]),
                (item.id === __props.modelValue)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_6, [...(_cache[5] || (_cache[5] = [
                      _createElementVNode("path", { d: "m5 12 4 4L19 6" }, null, -1)
                    ]))]))
                  : _createCommentVNode("", true)
              ], 42, _hoisted_3))
            }), 128))
          ], 44, _hoisted_2))
        : _createCommentVNode("", true)
    ]))
  ], 2))
}
}

})